import type React from "react";
import { type PropsWithChildren } from "react";
import { cn } from "~/lib/utils";

interface Props extends PropsWithChildren {
  title: string;
  button?: React.ReactNode;
  className?: string;
}

export const DashboardCard = ({
  title,
  children,
  button,
  className,
}: Props) => (
  <div
    className={cn(
      "flex max-h-120 flex-col gap-2 overflow-auto rounded-lg bg-white px-3 pt-3 shadow-md",
      className,
    )}
  >
    <div className="flex justify-between">
      <p className="text-lg font-medium">{title}</p>
      {button}
    </div>
    {children}
  </div>
);
